/* eslint-disable eag/no-css-property */
import {getCssSize, VStack} from 'platform/foundation';
import {css} from 'styled-components';

import {RichContentDisplay} from '@chat/ui';

import {EventDate} from './EventDate';
import {Text} from './richContent/Text';

const CustomerTopArrow = () => (
  <svg width="16" height="6" viewBox="0 0 16 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 4.47214V6H0L10.2111 0.894427C12.8708 -0.435375 16 1.49861 16 4.47214Z"
      fill="#3E47DD"
    />
  </svg>
);

interface CustomerMessageProps {
  message: string;
  createdAt: string;
  isRead: boolean;
}

export function CustomerMessage(props: CustomerMessageProps) {
  return (
    <VStack align="flex-end">
      <CustomerTopArrow />
      <div
        css={css`
          background-color: ${({theme}) => theme.colors.accent.base};
          padding: ${getCssSize(3)};
          border-top-left-radius: ${getCssSize(2)};
          border-bottom-right-radius: ${getCssSize(2)};
          border-bottom-left-radius: ${getCssSize(2)};
          margin-bottom: ${getCssSize(1)};
        `}
      >
        <RichContentDisplay
          markdown={props.message}
          ContentEditableComponent={<Text type="customer" />}
        />
      </div>
      <EventDate timestamp={props.createdAt} isRead={props.isRead} />
    </VStack>
  );
}
